import React from 'react';
import Moment from 'moment';
import { t } from '../../../../i18n'
import Pagination from '../../shared/Pagination';


const Row = ({description , date, points}) => {
  
  const validDescription = description || "-"
  const parsedPoints = parseFloat(points)
  const normalizedPoints = parsedPoints % 1 === 0 ? parsedPoints.toFixed(0) : parsedPoints

  return (
    <tr className="gl-rankings__data text-sm my-5 vodafone font-normal">
      <td className="text-left">
        <p>{validDescription}</p>
      </td>
      <td className="text-center">
        <p>{Moment(date).format(t('date-format'))}</p>
      </td>
      <td className="text-right">
        <p>{normalizedPoints}</p>
      </td>
    </tr>
  )
}

const BalanceTable = props => {

  const {
    points,
    rankingLabel,
    totalPages,
    page,
    onPageChange
  } = props

  return(
    <div className='gl-rankings__table-container'>
      <table className='gl-rankings__table overflow-x-auto w-full text-size'>
        <thead className='my-10 text-left'>
          <tr className='gl-rankings__table-header py-5 my-5'>
            <th className='gl-rankings__table-header pt-3 pb-3'>Descrição</th>
            <th className='gl-rankings__table-header text-center pt-3 pb-3'>Data</th>
            <th className='gl-rankings__table-header text-right pt-3 pb-3 whitespace-no-wrap'>{rankingLabel.currencyLabel}</th>
          </tr>
        </thead>
        <tbody>
          {points && points.map((e, key) =><Row key={key} {...e}/> )}
        </tbody>
      </table> 
      { totalPages > 1  &&
        <div className="text-sm flex justify-end mt-10">
          <Pagination
            totalPages={totalPages}
            currentPage={page}
            onPageChange={onPageChange}/>
        </div>
        }
    </div>
   )
}

export default BalanceTable